import { useContext } from 'react';
import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';
import type { FirmUser } from '@/_types/models/user';

export const useFirmUser = (
  userId: number | null | undefined,
): FirmUser | undefined => {
  const { firmUsers } = useContext(FirmSettingsContext);
  if (!userId) return undefined;
  return firmUsers.find((user) => user.id === userId);
};
